/**
 * @generated SignedSource<<ef059a3bf7025544a090270585313b63>>
 * @relayHash 30b3b4c98728e6d8df90bcd7260947b0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c0da0df7a2cc14efe99be26c64e2273a2f486581c7042e7c7c380792413310fa

import type { ConcreteRequest } from 'relay-runtime';
export type JiraDeploymentsFeaturePrecondition = "ALL_SATISFIED" | "DEPLOYMENTS_EMPTY_STATE" | "NOT_AVAILABLE" | "%future added value";
export type PreconditionCheckQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type PreconditionCheckQuery$data = {
  readonly jira: {
    readonly deploymentsFeaturePreconditionByProjectKey: JiraDeploymentsFeaturePrecondition;
  };
};
export type PreconditionCheckQuery = {
  response: PreconditionCheckQuery$data;
  variables: PreconditionCheckQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = {
  "args": [
    {
      "kind": "Variable",
      "name": "cloudId",
      "variableName": "cloudId"
    },
    {
      "kind": "Variable",
      "name": "projectKey",
      "variableName": "projectKey"
    }
  ],
  "kind": "ScalarField",
  "name": "deploymentsFeaturePreconditionByProjectKey"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PreconditionCheckQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": (v1/*: any*/),
              "action": "THROW"
            }
          ]
        },
        "action": "THROW"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PreconditionCheckQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "c0da0df7a2cc14efe99be26c64e2273a2f486581c7042e7c7c380792413310fa",
    "metadata": {},
    "name": "PreconditionCheckQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "03cf79a1a58a23b75e425cb6cdf7a7e6";

export default node;
